import React from 'react';
import { Button } from 'primereact/button';

export default function SJBanner() {
  return (
    <div className="container bg-primary mx-auto px-4 py-8 md:py-12 lg:py-16">
      <div className="grid align-items-center">
        {/* Left Section: Text Content */}
        <div className="col-12 md:col-7 lg:col-6 order-1 md:order-0">
          <div className="banner-text">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight">
              Beyond Compliance <br />
              <span className="" style={{color:'#fab50f'}}>Advisory for Next - Level Growth</span>
            </h1>
            
            {/* <div className="cta-link mt-5">
              <Button 
                label="Get Help" 
                icon="pi pi-arrow-right" 
                iconPos="right" 
                className="p-button-primary p-button-lg" 
                style={{ padding: '0.75rem 1.5rem' }}
              />
            </div> */}
          </div>
        </div>

        {/* Right Section: Image */}
        <div className="col-12 md:col-5 lg:col-6 order-0 md:order-1">
          <div className="banner-image flex justify-center md:justify-end">
            <img
              src="./homepage.jpg"
              alt="Virtual CFO"
              className="w-full border-round shadow-2"
              style={{ 
                maxHeight: '450px', 
                objectFit: 'cover',
                borderRadius: '12px'
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}